import { Box, Button, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";
import { SeV2AnnouncementDto } from "../../../../autogen/bff-api";
import { AnnouncementCard } from "../../../../common/components/communication/AnnouncementCard";
import { PublishInformasjonModal } from "./PublishInformasjonModal";

export const InformasjonComposer = ({
  eventId,
  announcements,
}: {
  eventId: string;
  announcements: SeV2AnnouncementDto[];
}) => {
  const { t } = useTranslation();
  const modal = useDisclosure();

  return (
    <Stack spacing="4">
      <Box>
        <Button leftIcon={<FiPlus />} colorScheme="teal" onClick={modal.onOpen}>
          {t("New information")}
        </Button>
      </Box>
      {announcements.length === 0 ? (
        <Box py="10" textAlign="center" color="smMuted">
          <Text>{t("No information published")}</Text>
        </Box>
      ) : (
        announcements.map((announcement) => <AnnouncementCard key={announcement.id} announcement={announcement} />)
      )}
      <PublishInformasjonModal eventId={eventId} isOpen={modal.isOpen} onClose={modal.onClose} />
    </Stack>
  );
};
